import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getProducts, getFaqs } from "@/lib/api";
import { useSEO, orgSchema, websiteSchema } from "@/lib/seo";
import Hero from "@/components/home/Hero";
import HeroSpotlight from "@/components/home/HeroSpotlight";
import TrustStrip from "@/components/home/TrustStrip";
import FeaturedProducts from "@/components/home/FeaturedProducts";
import QualityTransparency from "@/components/home/QualityTransparency";
import Manifesto from "@/components/home/Manifesto";
import FaqPreview from "@/components/home/FaqPreview";
import BrandMarquee from "@/components/motion/Marquee";

export default function Home() {
  const { data: productData } = useQuery({ queryKey: ["products"], queryFn: () => getProducts() });
  const { data: faqsData = [] } = useQuery({ queryKey: ["faqs"], queryFn: getFaqs });

  const products = Array.isArray(productData?.products) ? productData.products : [];
  const featured = products.filter((p) => p.featured).slice(0, 4);
  const faqs = Array.isArray(faqsData) ? faqsData : [];

  const faqSchema = faqs.length
    ? {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.slice(0, 6).map((f) => ({
          "@type": "Question",
          name: f.question,
          acceptedAnswer: { "@type": "Answer", text: f.answer },
        })),
      }
    : null;

  useSEO({
    title: "Renova Peptide Co. | Premium Research Peptides",
    description:
      "Explore research-focused compounds from Renova Peptide Co., presented with clarity, professional product information, and a commitment to premium service.",
    path: "/",
    jsonLd: [orgSchema, websiteSchema, faqSchema].filter(Boolean),
  });

  return (
    <>
      <Hero />
      <HeroSpotlight />
      <TrustStrip />
      <FeaturedProducts products={featured} />
      <BrandMarquee />
      <QualityTransparency />
      <Manifesto />
      <FaqPreview faqs={faqs.slice(0, 6)} />
    </>
  );
}
